<div class="modal-body p-0">
   <app-limit-reached-card [canUpgrade]="canUpgrade" [isCompInsidePopup]="true" [title]="title" [message]="message"></app-limit-reached-card>
</div>
